export function getLocalStorage(key: string) {
  return localStorage.getItem(key);
}

export function setLocalStorage(key: string, value: any): void {
  localStorage.setItem(key, value);
}

export function removeLocalStorage(key: string): void {
  localStorage.removeItem(key);
}
